import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/Index/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: index,
  },
  {
    path: '/List',  // 列表
    name: '/List',
    component: () => import('../views/List/index.vue')
  },
  {
    path: '/MoreList',  //更多列表
    name: '/MoreList',
    component: () => import('../views/MoreList/index.vue')
  },
  
  {
    path: '/Set',  // 个人中心
    name: '/Set',
    component: () => import('../views/Set/index.vue')
  },
  
  // {
  //   path: '/Login',  // 登录
  //   name: '/Login',
  //   component: () => import('../views/Set/login.vue')
  // },
  
  {
    path: '/User/Login',  // 登录
    name: 'User/Login',
    component: () => import('../views/User/Login')
  },
  {
    path: '/User/Register',  // 注册
    name: 'User/Register',
    component: () => import('../views/User/Register')
  },
  
  {
    path: '/User/Forget',  // 忘记密码
    name: 'User/Forget',
    component: () => import('../views/User/Forget')
  },
  
  // {
  //   path: '/Dmain',  // 翻书
  //   name: 'Dmain',
  //   component: () => import('../views/Reader/Dmain.vue')
  // },
  {
    path: '/502',  // 维护中
    name: '502',
    component: () => import('@/views/502/index.vue')
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
